import { WitaConnector } from '@/services/repository/connector'
import { FormDataHandler } from '@/utils/helpers/FormDataHandler'
import { querySerializer } from '@/utils/helpers/URLs'

import { Repo } from './Equipment.d'

const ROOT_URL = '/entity/equipments'

export const EquipmentRepository = {
  Search: async (params: Repo.Equipment.Search.Params) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<Repo.Equipment.Search.Response>(url)
  },

  FindById: async ({ equipmentId }: Repo.Equipment.FindById.Params) => {
    const url = ROOT_URL + `/${equipmentId}`
    return await WitaConnector.get<Repo.Equipment.FindById.Response>(url)
  },

  Create: async (params: Repo.Equipment.Create.Params) => {
    const formData = FormDataHandler(params)
    const url = ROOT_URL
    return await WitaConnector.post<Repo.Equipment.Create.Response>(
      url,
      formData,
    )
  },

  Edit: async ({ id, ...params }: Repo.Equipment.Edit.Params) => {
    const formData = FormDataHandler(params)
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.put<Repo.Equipment.Edit.Response>(url, formData)
  },
}
